export function getItemsFilter<Item>(selectedItems: string[], key: keyof Item) {
  return function itemsFilter(item: Item): boolean {
    const itemKey = item[key] as unknown as string;
    return !selectedItems.includes(itemKey);
  };
}

export function valueToArray(
  value: number | string | readonly string[] | undefined,
  separator = ';',
): string[] {
  if (Array.isArray(value)) {
    return value;
  } else if (typeof value === 'string') {
    return value
      .split(separator)
      .map((v) => v.trim())
      .filter(Boolean);
  } else if (typeof value === 'number') {
    return [String(value)];
  } else {
    return [];
  }
}
